/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Italian (Italy)
export default {
  'confluence-analytics-chart.default-loading-text': 'Aggiornamento dei dati di analisi in corso...',
  'confluence-analytics-chart.tooltip.no-views-data': 'Nessun dato',
  'confluence-analytics-chart.tooltip.views-overall':
    '{count, plural, one {1 visualizzazione} other {{count} visualizzazioni}}',
  'confluence-analytics-chart.tooltip.views-today-so-far':
    '{count, plural, one {1 visualizzazione finora} other {{count} visualizzazioni finora}}',
  'confuence-analytics-chart.accessible-table.caption': 'Visualizzazioni della pagina',
  'confuence-analytics-chart.accessible-table.header.date': 'Data',
  'confuence-analytics-chart.accessible-table.header.view-count': 'Visualizzazioni',
  'confuence-analytics-chart.accessible-table.no-view-count-data': 'Nessuna visualizzazione',
};
